
const getSiteFromDomain = (domain: string) => {
	switch (domain) {
		case "nl.travelski.com":
		case "www.nl.travelski.com": {
			return 'www.nl.travelski.com';
		}
		case "uk.travelski.com":
		case "www.uk.travelski.com": {
			return 'www.uk.travelski.com';
		}
		default: {
			return 'www.travelski.com';
		}
	}
};

export default getSiteFromDomain;
